import { UserPhoneCountryCode } from '../api/account-settings.api';

interface UserPhoneSetting {
    placeholder: string;
    format: string;
    flag: '';
    name: string;
    regexp: RegExp;
}

export const UserPhoneConfig: Record<UserPhoneCountryCode, UserPhoneSetting> = {
    [UserPhoneCountryCode.AU]: {
        regexp: /^[0-9]{4} [0-9]{3} [0-9]{3}$/,
        format: '9999 999 999',
        placeholder: '9999 999 999',
        flag: require('../assets/au.svg'),
        name: 'Australia',
    },
    [UserPhoneCountryCode.US]: {
        regexp: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
        format: '(999) 999-9999',
        placeholder: '(999) 999-9999',
        flag: require('../assets/us.svg'),
        name: 'USA',
    },
    [UserPhoneCountryCode.CA]: {
        regexp: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
        format: '(999) 999-9999',
        placeholder: '(999) 999-9999',
        flag: require('../assets/ca.svg'),
        name: 'Canada',
    },
};
